import { ReceiptBaseDtoStatusEnum, ReceiptDtoStatusEnum } from '@/api/types';
import { Badge } from '@/components/ui/badge.tsx';

type ReceiptStatusProps = {
  status: ReceiptDtoStatusEnum | ReceiptBaseDtoStatusEnum;
};

const ReceiptStatus = ({ status }: ReceiptStatusProps) => {
  switch (status) {
    case ReceiptDtoStatusEnum.Processed:
      return <Badge variant="success">Processed</Badge>;
    case ReceiptDtoStatusEnum.Failed:
      return <Badge variant="destructive">Failed</Badge>;
    case ReceiptDtoStatusEnum.Loaded:
      return <Badge variant="info">Loaded</Badge>;
    case ReceiptDtoStatusEnum.Created:
    default:
      return <Badge variant="outline">Created</Badge>;
  }
};

export default ReceiptStatus;
